import bugsnagClient from '@/ui/containers/BugsnagClient';
import { parseAllTikTokTimeSeriesQuery } from 'utils/helpers';
import { useTikTokDataPoints } from 'utils/hooks/api';

export const useTikTokWatchlistTimeSeriesData = ({
    country,
    categoryIds,
    brandIds,
    hashtagBrandIds,
    hashtagCategoryIds,
    placeholderTsDataByType,
}) => {
    const baseTikTokTsParams = {
        week: null,
        year: null,
        per_page: 500,
        page: 1,
    };

    const [tsBrandsQuery] = useTikTokDataPoints({
        brands: brandIds,
        enabled: !!country && !!brandIds,
        countries: country ? [country.id] : null,
        staleTime: Infinity,
        ...baseTikTokTsParams,
        placeholderData: placeholderTsDataByType.brand.map((e) => e),
    });

    const [tsCategoriesQuery] = useTikTokDataPoints({
        categories: categoryIds,
        countries: country ? [country.id] : null,
        enabled: !!country && !!categoryIds,
        staleTime: Infinity,
        ...baseTikTokTsParams,
        placeholderData: placeholderTsDataByType.category.map((e) => e),
    });
    const [tsHashtagBrandsQuery] = useTikTokDataPoints({
        hashtags: hashtagBrandIds.map(({ id }) => id),
        countries: country ? [country.id] : null,
        enabled: !!country && !!hashtagBrandIds.length,
        staleTime: Infinity,
        ...baseTikTokTsParams,
        placeholderData: placeholderTsDataByType.hashtagBrand.map((e) => e),
    });

    const [tsHashtagCategoriesQuery] = useTikTokDataPoints({
        hashtags: hashtagCategoryIds.map(({ id }) => id),
        countries: country ? [country.id] : null,
        enabled: !!country && !!hashtagCategoryIds.length,
        staleTime: Infinity,
        ...baseTikTokTsParams,
        placeholderData: placeholderTsDataByType.hashtagCategory.map((e) => e),
    });
    // removed entries with no time series data JSON.parse
    const parseAllTikTokData = (
        parseAllTikTokTimeSeriesQuery(tsBrandsQuery, bugsnagClient) || []
    )
        .concat(
            parseAllTikTokTimeSeriesQuery(tsCategoriesQuery, bugsnagClient) ||
                [],
        )
        .concat(
            parseAllTikTokTimeSeriesQuery(
                tsHashtagBrandsQuery,
                bugsnagClient,
            ) || [],
        )
        .concat(
            parseAllTikTokTimeSeriesQuery(
                tsHashtagCategoriesQuery,
                bugsnagClient,
            ) || [],
        );
    return {
        parseAllTikTokData,
        tsBrandsQuery,
        tsCategoriesQuery,
        tsHashtagBrandsQuery,
        tsHashtagCategoriesQuery,
    };
};
